export class GoneError extends Error {
	statusCode = 410;

	constructor(public title: string = '410 Gone') {
		super(title);
	}
}
